import { render, staticRenderFns } from "./TheRegularBasic.vue?vue&type=template&id=66803568&scoped=true&"
import script from "./TheRegularBasic.vue?vue&type=script&lang=js&"
export * from "./TheRegularBasic.vue?vue&type=script&lang=js&"
import style0 from "./TheRegularBasic.vue?vue&type=style&index=0&id=66803568&prod&lang=less&scoped=true&"
import style1 from "./TheRegularBasic.vue?vue&type=style&index=1&id=66803568&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66803568",
  null
  
)

export default component.exports